module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/proposes"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Propose Title')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose Title')))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.goCreateTitle
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('New Registration')))])])])]), (_vm.callbackFlag) ? _c('div', [(!!_vm.proposeTasks) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.proposeTasks), function(ref, index) {
    var attributes = ref.attributes;
    var id = ref.id;

    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": ("/propose_task/" + id)
      }
    }, [_vm._v(_vm._s(attributes['task-title']))])], 1), _c('td', {
      staticClass: "hidden-xs",
      class: _vm.returnStatusClass(attributes['task-state'])
    }, [_vm._v(_vm._s(attributes['task-state-conversion']))]), _c('td', [_vm._v(_vm._s(_vm.formatDate(attributes['task-start-date'])) + "〜 \n" + _vm._s(_vm.formatDate(attributes['task-end-date'])))]), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-sm margin-right",
      attrs: {
        "type": "button",
        "disabled": _vm.returnIsDisabled(attributes['task-state'])
      },
      on: {
        "click": function($event) {
          _vm.goEditTitle(id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Edit')))]), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.returnIsDisabled(attributes['task-state'])
      },
      on: {
        "click": function($event) {
          _vm.deleteTitle(id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  }))])]), (!!_vm.proposeTasks && _vm.proposeTaskListNextPage) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default next-page-search-btn",
    on: {
      "click": function($event) {
        _vm.search(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Read More')))])])])]) : _vm._e()]) : _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("タイトル")]), _c('th', {
    staticClass: "col-sm-1 hidden-xs"
  }, [_vm._v("状態")]), _c('th', {
    staticClass: "col-sm-3"
  }, [_vm._v("公開日")]), _c('th', {
    staticClass: "col-sm-3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-613a2fbb!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-task-list.pug
// module id = 825
// module chunks = 1